// core version + navigation, pagination modules:
import Swiper from '@jsthirdparty/swiper';
// import Swiper and modules styles
import Pagination from '@jsthirdparty/swiper/modules/pagination.mjs';
import Autoplay from '@jsthirdparty/swiper/modules/autoplay.mjs';

// Selectors
const selector = {
  swiper: '.js-swiper-banner-doped',
  carouselWrapper: '.js-swiper-banner-doped .swiper-wrapper',
  swiperPagination: '.js-swiper-banner-doped .swiper-pagination'
};

// Elements
const element = {
  carouselWrapper: document.querySelector(selector.carouselWrapper) || null
};

// Variables
const carouselDelay = element?.carouselWrapper?.dataset?.carouselDelay;
const carouselSpeed = element?.carouselWrapper?.dataset?.carouselSpeed;
let swiper;
export default () => {
  // init Swiper:
  if (element.carouselWrapper) {
    swiper = new Swiper(selector.swiper, {
      modules: [Pagination, Autoplay],
      loop: true,
      // autoplay: {
      //   delay: carouselDelay,
      //   disableOnInteraction: false,
      //   pauseOnMouseEnter: true
      // },
      // If we need pagination
      pagination: {
        el: selector.swiperPagination,
        type: 'bullets',
        clickable: true
      },
      slidesPerView: 1
    });

    swiper.on('autoplay', function () {
      element.carouselWrapper.style.transition = `${carouselSpeed}ms ease-in-out`;
    });
  }
};
